<template>
    <step-choice
        tab-class="tab-dmp"
        headline="Nehmen Sie am DMP teil?"
        text="Das Disease-Management-Programm (DMP) ist ein freiwilliges Behandlungsprogramm für Menschen mit Typ-2-Diabetes. Es umfasst regelmäßige Kontrolltermine und Diabetes-Schulungen."
        :options="options"
        @answer="$emit('answer', $event)"
    ></step-choice>
</template>

<script>
import StepChoice from './StepChoice'

export default {
    components: { StepChoice },

    data() {
        return {
            options: [
                { label: 'Ja', value: true, icon: 'yes' },
                { label: 'Nein', value: false, icon: 'no' },
                { label: 'Ich bin mir nicht sicher', value: null, icon: 'unsure' }
            ]
        }
    }
}
</script>
